import { LoadingController } from 'ionic-angular';
import { GhostProvider } from './../../providers/ghost/ghost';
import { Tag } from './../../models/ghost/Tag';
import { Component, Output, EventEmitter } from '@angular/core';
/**
 * Generated class for the GuidesCategoriesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'guides-categories',
  templateUrl: 'guides-categories.html'
})
export class GuidesCategoriesComponent {
  @Output('tag') tag: EventEmitter<Tag> = new EventEmitter<Tag>();
  tags: Tag[] = null;

  constructor(public ghost: GhostProvider, public loadingCtrl: LoadingController) {
    const loader = this.loadingCtrl.create();
    loader.present();
    this.ghost.getGuidesTags().subscribe(tags => {
      this.tags = tags;
      loader.dismiss();
    }, error => {
      console.log(error);
      loader.dismiss();
    });
  }

  openTag(tag: Tag){
    this.ghost.singleTag = tag;
    this.tag.emit(tag);
  }

}



// WEBPACK FOOTER //
// ./src/components/guides-categories/guides-categories.ts